import { AnnouncementImportance } from "~/components/Forms/AnnouncementForm";
import { FilterField } from "~/features/filter";
import { AnnouncementStatus } from "~/schemas/generated/graphql";

type Translate = (key: string) => string;

/** Статусы, скрытые от пользователей без прав на смену статуса/редактирование */
const RESTRICTED_STATUSES: AnnouncementStatus[] = [
  AnnouncementStatus.Draft,
  AnnouncementStatus.Canceled,
];

/**
 * Поля фильтра страницы объявлений: текстовые поля, селекты и диапазон
 * дат создания — все в одну строку (dateRange с фиксированной шириной).
 */
export const announcementFilterFields = (
  t: Translate,
  canSeeAllStatuses: boolean,
): FilterField[] => {
  const statusOptions = Object.values(AnnouncementStatus)
    .filter((value) => canSeeAllStatuses || !RESTRICTED_STATUSES.includes(value))
    .map((value) => ({ value, label: t(`announcement.${value}`) }));

  const importanceOptions = Object.values(AnnouncementImportance).map(
    (value) => ({ value, label: t(`announcement.${value}`) }),
  );

  return [
    {
      name: "title",
      type: "input",
      label: t("announcement.title"),
    },
    {
      name: "text",
      type: "input",
      label: t("announcement.text"),
    },
    {
      name: "singedBy",
      type: "input",
      label: t("announcement.singedBy"),
    },
    {
      name: "importance",
      type: "select",
      label: t("announcement.importance"),
      options: importanceOptions,
    },
    {
      name: "status",
      type: "select",
      label: t("announcement.status"),
      options: statusOptions,
    },
    {
      name: "createdAtFrom",
      nameTo: "createdAtTo",
      type: "dateRange",
      label: t("employee.createAt"),
      placeholder: t("pkd.data_begin"),
      placeholderTo: t("pkd.data_end"),
      fixedWidth: 360,
      disableFutureDates: true,
    },
  ];
};
